import {
  Box,
  Text,
  Modal,
  Button,
  HStack,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import AmipassIcon from '../../../../components/SvgIcon/icons/Amipass'

export function LabelComponent() {
  const [open, setOpen] = useState(false)

  const handleToggleModal = () => {
    setOpen(!open)
  }

  return (
    <>
      <Box
        pt={2}
        pb={2}
        w="100%"
        gap={3}
        bottom={0}
        display="flex"
        cursor="pointer"
        flexDirection="row"
        position="absolute"
        alignItems="center"
        justifyContent="center"
        backgroundColor="#74BF00"
        onClick={handleToggleModal}
      >
        <AmipassIcon />
        <Text color="#fff" fontWeight={700}>
          Encuentra más locales en la aplicación
        </Text>
      </Box>

      <Modal isOpen={open} onClose={handleToggleModal} isCentered size="4xl">
        <ModalOverlay />
        <ModalContent backgroundColor="#f5f5f5" borderRadius={14}>
          <ModalBody p="20px 20px 20px 20px">
            <img
              src="https://assetsamipass.blob.core.windows.net/companies/dashboard/buscarProductos.png"
              alt="Buscar productos"
            />
            <HStack justifyContent="center">
              <Button
                mt={7}
                borderRadius={5}
                width="fit-content"
                onClick={handleToggleModal}
              >
                Cerrar ventana
              </Button>
            </HStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
